<template>
    <div>
        <el-input
            type="textarea"
            v-model="curdForm.remark"
            placeholder="请输入备注"
            :rows="10"
            maxlength="500"
            show-word-limit
        ></el-input>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-button type="primary" @click="save">保存</el-button>
            <el-button @click="closeRemarkDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                //表单数据
                curdForm: {
                    semesterCode: null,
                    classCode: null,
                    remark: null,
                },
            }
        },
        mounted() {
            this.queryRemark();
        },
        methods: {
            queryRemark(){
                this.$api.timetableManage.arrange.queryRemark({
                    data: this.curdForm,
                }).then((res) => {
                    this.curdForm.remark = res.data.data.remark;
                }).catch((err) => {
                    console.log(err);
                });
            },
            //关闭对话框
            closeRemarkDialog() {
                this.$emit('closeRemarkDialog');
            },
            save() {
                this.$api.timetableManage.arrange.saveRemark({
                    data: this.curdForm,
                }).then((res) => {
                    let state = res.data.data.state;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '保存成功', 'success', 1500);
                            this.queryList();
                            break;
                        default:
                            showNotify('错误', '保存失败', 'error', 3000);
                            break;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// remark.vue?411369e1